/**
 * Ensure Vipps Express initiate requests include Shopify cart discounts.
 *
 * Must load synchronously in <head> BEFORE the Vipps button-script, because
 * that script captures window.__nativeFetch once at startup.
 */
(function () {
  'use strict';

  if (window.__vippsDiscountBridgeInstalled) return;
  window.__vippsDiscountBridgeInstalled = true;

  var rawFetch = window.fetch.bind(window);

  function collectDiscountCodes(cart) {
    var codes = [];
    function push(value) {
      if (value == null) return;
      var s = String(value).trim();
      if (s) codes.push(s);
    }

    (cart.discount_codes || []).forEach(function (d) {
      if (d) push(d.code);
    });

    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (!d) return;
      push(d.code);
      push(d.title);
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc && alloc.discount_application;
        if (!app) return;
        push(app.code);
        push(app.title);
      });
      (item.discounts || []).forEach(function (d) {
        if (d) push(d.title);
      });
    });

    var seen = {};
    return codes.filter(function (c) {
      var key = c.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function mapCartItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(function (i) {
      return {
        variantId: String(i.variant_id),
        quantity: i.quantity,
        price: i.price / 100,
        productTitle: i.product_title || '',
        variantTitle:
          i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '',
        imageUrl: (i.featured_image && i.featured_image.url) || i.image || '',
        properties: i.properties || {},
      };
    });
  }

  async function enrichVippsInitiate(init) {
    var cartRes = await rawFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!cartRes.ok) return init;

    var cart = await cartRes.json();
    var body = {};
    try {
      body = JSON.parse((init && init.body) || '{}');
    } catch (e) {
      return init;
    }

    var fromCart = collectDiscountCodes(cart);
    var merged = [];
    var seen = {};
    (body.discountCodes || [])
      .concat(fromCart)
      .forEach(function (c) {
        if (!c) return;
        var key = String(c).trim().toLowerCase();
        if (!key || seen[key]) return;
        seen[key] = true;
        merged.push(String(c).trim());
      });

    var hasDiscountMoney = !!(cart.total_discount && cart.total_discount > 0);
    var hasDiscountApps = !!(
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length
    );
    var hasDiscounts = merged.length > 0 || hasDiscountMoney || hasDiscountApps;

    body.discountCodes = merged;
    if (cart.token) body.cartToken = cart.token;

    var looksLikeProductOnly =
      !!body.currentVariantId &&
      (!body.cartItems || body.cartItems.length === 0) &&
      body.useExistingCart === false;

    if (looksLikeProductOnly && hasDiscounts) {
      var variantInCart = (cart.items || []).some(function (i) {
        return String(i.variant_id) === String(body.currentVariantId);
      });
      if (variantInCart) {
        // Same variant already discounted in cart — reuse that cart.
        body.cartItems = mapCartItems(cart);
        body.useExistingCart = true;
        body.totalAmount = cart.total_price / 100;
      }
      // Always pass codes so Vipps can re-apply on a fresh product checkout too.
      body.discountCodes = merged;
    } else if (cart.items && cart.items.length) {
      // Cart drawer / generic express
      body.useExistingCart = true;
      if (!body.cartItems || !body.cartItems.length) {
        body.cartItems = mapCartItems(cart);
      }
      body.totalAmount = cart.total_price / 100;
      body.discountCodes = merged;
    }

    return Object.assign({}, init || {}, {
      body: JSON.stringify(body),
      headers: Object.assign({}, (init && init.headers) || {}, {
        'Content-Type': 'application/json',
      }),
    });
  }

  function bridgedFetch(input, init) {
    var url = '';
    try {
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;
    } catch (e) {}

    var method = (init && init.method) || (input && input.method) || 'GET';
    var isVippsInitiate =
      /\/apps\/vipps\/vipps\/initiate\/?(\?|$)/i.test(url) &&
      String(method).toUpperCase() === 'POST';

    if (!isVippsInitiate) {
      return rawFetch(input, init);
    }

    return enrichVippsInitiate(init || {}).then(function (nextInit) {
      return rawFetch(input, nextInit);
    });
  }

  window.__nativeFetch = bridgedFetch;
  window.fetch = bridgedFetch;
})();
